
<div class="app-col-2-layout">
  <!-- <div>
    <ng-container
      appDynamicComponent
      [components]="headerSection"
      [instanceData]="headerSectionInstanceData"
      class="mb-4 d-print-none header header-sticky"
      position="sticky" sidebarId="sidebar"
    ></ng-container>
  </div> -->
  <div class="main-section">
    <ng-container
      appDynamicComponent
      [components]="leftSection"
      [instanceData]="leftSectionInstanceData"
    ></ng-container>
  </div>
</div>
